import { ICON__link } from '@/assets/icons_fa';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { cn } from '@/utils/utils_client';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { useState } from 'react';
import { G_CONTEXT_MENU__field } from './context_menu/G_CONTEXT_MENU__field';
import { G_UI_FIELD__overlay_not_used } from './G_UI_FIELD__overlay_not_used';

interface PROPS {
  children: React.ReactNode;
  field: FIELD__base;
  className?: string;
  data__is_linked?: boolean;
}

export function G_UI_FIELD__wrapper({ children, field, className, data__is_linked = false }: PROPS) {
  const { g_image_edit__field, g_general__layout } = use_slice_ui(['g_image_edit__field', 'g_general__layout']);

  /*
   * STATE
   */

  const [is_hovered, set_is_hovered] = useState(false);

  /*
   * METHODS
   */

  function get_image_edit_border() {
    let class_name_no_border = 'border-2 border-transparent';

    if (g_general__layout != ENUM__page_generation_layout.ASSETS) return class_name_no_border;

    let class_name_border = 'border-2 border-component-item-border rounded-lg';

    if (is_field_selected()) return class_name_border;
    if (is_hovered) return class_name_border;

    return class_name_no_border;
  }

  function is_field_selected() {
    return field.meta.field_id == g_image_edit__field.meta.field_id;
  }

  function get_class_opacity() {
    if (is_field_selected()) return 'opacity-100';
    if (is_hovered) return 'opacity-100';
    if (field.meta.kind__is_output) return 'opacity-25';
    if (field.meta.ui__is_readonly) return 'opacity-25';

    return '';
  }

  /*
   * RENDERS
   */

  function render_data_linked() {
    if (!data__is_linked) return null;
    if (is_hovered) return null;

    return <ICON__link className="absolute top-1.5 right-2 size-3 text-bar-foreground pointer-events-none" />;
  }

  /*
   * HTML
   */

  return (
    <div
      className={cn(
        `relative 
        flex flex-col 
        w-full min-w-0 
        border border-t border-component-border first:border-t-0
        overflow-y-auto
                  `,
        className,
      )}
    >
      <div
        onMouseEnter={() => set_is_hovered(true)}
        onMouseLeave={() => set_is_hovered(false)}
        data-field-id={field.meta.field_id}
        className={`w-full min-w-0
                    ${get_class_opacity()}
                    ${get_image_edit_border()}
                  `}
      >
        <G_CONTEXT_MENU__field {...{ field }}>{children}</G_CONTEXT_MENU__field>
        <G_UI_FIELD__overlay_not_used {...{ field }} is_visible={!is_hovered} />
      </div>

      {render_data_linked()}
    </div>
  );
}
